import { render } from "./rarity.vue?vue&type=template&id=2e48c292&scoped=true"
import script from "./rarity.vue?vue&type=script&lang=js"
export * from "./rarity.vue?vue&type=script&lang=js"

import "./rarity.vue?vue&type=style&index=0&id=2e48c292&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e48c292"]])

export default __exports__